export default __webpack_public_path__ + "static/media/logo.f199a506.webp";